import { render, staticRenderFns } from "./Mked.vue?vue&type=template&id=00be683c&scoped=true"
import script from "./Mked.vue?vue&type=script&lang=ts"
export * from "./Mked.vue?vue&type=script&lang=ts"
import style0 from "./Mked.vue?vue&type=style&index=0&id=00be683c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00be683c",
  null
  
)

export default component.exports